import React, { useContext } from 'react'
import CategoryHeader from '../../components/CategoryHeader'
import MessagesWidget from '../../components/MessagesWidget/MessagesWidget'
import Notifications from '../../components/Notifications/Notifications'
import OrdersWidget from '../../components/OrdersWidget/OrdersWidget'
import { TibiContext } from '../../context/ContextProvider'
import DeliveriesWidget from '../../components/DeliveriesWidget/DeliveriesWidget'
import NewOrderButton from '../../components/NewOrderButton/NewOrderButton'

const DashboardIndex: React.FunctionComponent = () => {
    // Auth hook for components
    const { value }: any = useContext(TibiContext)
    const user = value?.user

    const deliveriesWidgetSize = 4

    return (
        <div className='w-full h-full flex flex-col space-y-6 my-2 '>
            <div>
                <h2 className='text-lg sm:text-2xl mb-0'>
                    Welkom, <span className='capitalize'>{user?.name}</span>
                </h2>
            </div>

            <div className='flex justify-between items-center my-2 flex-wrap gap-4'>
                <CategoryHeader iconName='shopping-basket' title='Lopende opdrachten' />
                <NewOrderButton />
            </div>
            <OrdersWidget limit={4} />
            <div className='flex flex-col gap-y-4 lg:gap-y-0 lg:flex-row lg:gap-x-4'>
                <MessagesWidget />
                <Notifications />
            </div>

            <CategoryHeader iconName='download' title='Laatste opleveringen' />
            <DeliveriesWidget size={deliveriesWidgetSize} />
        </div>
    )
}

export default DashboardIndex
